import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQueryWithReauth } from './baseQuery';
import { GetAlertsByDay, AlertReportRequestParams } from 'src/types/alertReport';
import { DataDTOAlertByDay, DataDTOProductWithAlert, DataDTOItemTrackersStatusSummary } from 'src/types/api/generated/api';

export const alertReportsAPI = createApi({
    reducerPath: 'alertReportsAPI',
    baseQuery: axiosBaseQueryWithReauth({
        baseUrl: process.env.REACT_APP_API_URL
    }),
    tagTypes: ['AlertReports'],
    endpoints: (builder) => ({
        getHighestCostAlerts: builder.query<DataDTOProductWithAlert[], AlertReportRequestParams>({
            query: ({ storeId, takeCount, startDate, endDate, intelligencePointId }) => ({
                url: `Reports/HighestCostAlerts/${storeId}`,
                method: 'GET',
                params: {
                    takeCount,
                    startDate,
                    endDate,
                    intelligencePointId
                }
            })
        }),
        getAlertsByDay: builder.query<DataDTOAlertByDay[], GetAlertsByDay>({
            query: ({ storeId, startDate, endDate, intelligencePointId }) => ({
                url: `Reports/AlertsByDay/${storeId}`,
                method: 'GET',
                params: {
                    startDate,
                    endDate,
                    intelligencePointId
                }
            })
        }),
        getMostExpensiveTrackedProducts: builder.query<DataDTOProductWithAlert[], AlertReportRequestParams>({
            query: ({ storeId, takeCount, startDate, endDate, intelligencePointId }) => ({
                url: `Reports/GetMostExpensiveTrackedProducts/${storeId}`,
                method: 'GET',
                params: {
                    takeCount,
                    startDate,
                    endDate,
                    intelligencePointId
                }
            })
        }),
        getMostAlertedProducts: builder.query<DataDTOItemTrackersStatusSummary[], AlertReportRequestParams>({
            query: ({ storeId, takeCount, startDate, endDate, intelligencePointId }) => ({
                url: `Reports/MostAlertedProducts/${storeId}`,
                method: 'GET',
                params: {
                    takeCount,
                    startDate,
                    endDate,
                    intelligencePointId
                }
            })
        })
    }),
});

export const {
    useGetHighestCostAlertsQuery,
    useGetAlertsByDayQuery,
    useGetMostExpensiveTrackedProductsQuery,
    useGetMostAlertedProductsQuery
} = alertReportsAPI;
